import React, { useState } from "react";
import Typewriter from "typewriter-effect";
import { BookOpen } from "lucide-react";
import {
  Menu,
  Facebook,
  Linkedin,
  Twitter,
  MessageCircle,
  Send,
  XCircle,
} from "lucide-react";
import { FaInstagram } from "react-icons/fa"; 
import gif from "../../Images/1.png";
import professionalAvatar from "../../Images/professionalAvatar.png";
import { useNavigate } from "react-router-dom";

function Landing() {
  const [isOpen, setIsOpen] = useState(false);
  const words = ["Partners", "Employees", "Customers", "Users"];

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    document.body.style.overflow = !isOpen ? "hidden" : "unset";
  };

  const navigate = useNavigate();
  const [holdTimer, setHoldTimer] = useState(null);

  const handleHoldStart = () => {
    const timer = setTimeout(() => {
      navigate("/blogs", { state: { userType: "admin" } });
    }, 5000);
    setHoldTimer(timer);
  };

  const handleHoldEnd = () => {
    if (holdTimer) {
      clearTimeout(holdTimer);
      setHoldTimer(null);
    }
  };

  const handleRedirect = () => {
    navigate("/blogs", { state: { userType: "user" } });
  };

  const handleLogin = () => {
    window.location.href = "https://app.attest360.com/bgv/login";
  };

  return (
    <>
      <div className="bg-white lg:h-dvh select-none">
        <div className="flex flex-col lg:flex-row min-h-screen">
          {/* <div className="w-screen lg:w-24 bg-white">
          </div> */}

          <div className="flex-1 flex flex-col lg:flex-row relative">
          <div className="w-full lg:w-1/2 relative h-screen overflow-hidden">
    <img
      src={gif}
      alt="Professional portrait"
      className="w-full h-full object-top transition-transform duration-500 ease-in-out animate-fade"
    />
    <div className="absolute inset-0 bg-black/10" />
  </div>

            <div className="w-full lg:w-1/2 flex flex-col justify-start p-6 lg:p-20 space-y-12 relative">
              {/* <div className="flex justify-center lg:justify-center space-x-6 mb-6"></div> */}
              <div className="flex justify-right lg:justify-right space-x-6 mb-6">
                <a
                  href="https://www.facebook.com/profile.php?id=61576150105402"
                  className="text-gray-600 hover:text-[#C4392A] transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Facebook size={30} />
                </a>
                <a
                  href="https://x.com/CriterionScrenr?t=f2F_a1apRogglPrnSt6Z4Q&s=08"
                  className="text-gray-600 hover:text-[#C4392A] transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Twitter size={30} />
                </a>
                <a
                  href="https://www.instagram.com/verifydigital?utm_source=qr&igsh=aWRiaG10dDUxZDMz"
                  className="text-gray-600 hover:text-[#C4392A] transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaInstagram size={30} />
                </a>
                <a
                  href="https://www.linkedin.com/company/criterion-screeners/posts/?feedView=all"
                  className="text-gray-600 hover:text-[#C4392A] transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Linkedin size={30} />
                </a>
              </div>

              <div className="space-y-6 mt-[-2rem]">
                <h1 className="text-5xl lg:text-7xl font-bold leading-tight lg:leading-snug">
                  We
                  <br />
                  Unlock
                  <br />
                  Real
                  <br />
                  <span className="bg-gradient-to-r from-[#e4220d] to-[#ac0000] bg-clip-text text-transparent">
                      <Typewriter
                        options={{
                          strings: words,
                          autoStart: true,
                          loop: true,
                          deleteSpeed: 50,
                          delay: 100,
                          wrapperClassName: "gradient-text", // Custom class for the text
                        }}
                      />
                    </span>
                </h1>

                <div className="flex items-center space-x-4">
                  <span
                    className="text-gray-600 cursor-pointer group flex items-center space-x-3 hover:text-[#C4392A] transition-all duration-300"
                    onClick={handleRedirect}
                  >
                    <BookOpen
                      size={28} 
                      className="text-gray-600 group-hover:text-[#C4392A] group-hover:scale-110 group-hover:-rotate-6 transition-all duration-300"
                    />
                    <span className="relative font-medium text-xl">
                      {" "}
                      {/* Increased from default (~16px) to 20px */}
                      View Blogs
                      <span className="absolute -bottom-1 left-0 w-0 h-1 bg-[#C4392A] rounded-full group-hover:w-full transition-all duration-300 ease-in-out" />
                    </span>
                  </span>
                  <div id="why-us" className="w-16 h-0.5 bg-[#C4392A]" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Landing;
